
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j01vW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $3gadb = parcelRequire("3gadb");


var $7XIdu = parcelRequire("7XIdu");


var $4oTqF = parcelRequire("4oTqF");


var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jEPJt = parcelRequire("jEPJt");





var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");




const $ef3ef5463323e3eb$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?"
        })
    });
const $ef3ef5463323e3eb$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested"
        })
    });
const $ef3ef5463323e3eb$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later"
        })
    });
const $ef3ef5463323e3eb$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater, customDropdownItems: customDropdownItems })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
        children: [
            customDropdownItems?.map((item)=>item),
            showRemindMeLater && /*#__PURE__*/ (0, $l998X.jsx)($ef3ef5463323e3eb$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($ef3ef5463323e3eb$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $l998X.jsx)($ef3ef5463323e3eb$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });


/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");











var $4ORml = parcelRequire("4ORml");

const $f4e4a51aca50752c$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content'; /*--Modal--*/ 
const $f4e4a51aca50752c$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $4ORml.portalZIndexFix)($f4e4a51aca50752c$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: $f4e4a51aca50752c$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $f4e4a51aca50752c$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK"
        })
    }); /*--Title--*/ 
const $f4e4a51aca50752c$var$titleContainerStyles = {
    font: "_11c81af2"
};
const $f4e4a51aca50752c$var$Title = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $f4e4a51aca50752c$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?"
        })
    }); /*--Body--*/ 
const $f4e4a51aca50752c$var$DefaultBody = ()=>/*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:"
        })
    }); /*--Reasons List--*/ 
const $f4e4a51aca50752c$var$reasonsListStyles = null;
const $f4e4a51aca50752c$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        className: (0, $gMc0m.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
                children: reason
            }, index))
    }); /*--Privacy Policy Link--*/ 
const $f4e4a51aca50752c$var$privacyPolicyLinkWrapperStyles = null; /**
                                              * Translated link to Atlassian's privacy policy.
                                              */ 
const $f4e4a51aca50752c$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian"
            })
        })
    }); /*--Reason Modal--*/ 
const $f4e4a51aca50752c$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                    children: content?.title || /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                children: content?.body || /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $f4e4a51aca50752c$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f4e4a51aca50752c$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};


const $695eea2d8c17034b$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ariaLabelledby: ariaLabelledby, ...triggerProps })=>{
    const intl = (0, $aXWIB.useIntl)();
    const ariaLabel = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.aria-label",
        defaultMessage: "{messageInstanceId} options menu"
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.tooltip",
        defaultMessage: "More actions"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $3gadb.default), {
        content: tooltip,
        isScreenReaderAnnouncementDisabled: true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                hidden: true,
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...triggerProps,
                label: tooltip,
                id: "ad-controls-trigger",
                appearance: "subtle",
                ref: triggerRef,
                spacing: spacing,
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        ...iconProps,
                        color: iconColor,
                        size: iconSize
                    }),
                "aria-labelledby": ariaLabelledby ? `${ariaLabelledby} ad-controls-trigger` : 'ad-controls-trigger'
            })
        ]
    });
};
const $695eea2d8c17034b$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default', customDropdownItems: customDropdownItems, ariaLabelledby: ariaLabelledby })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $42omo.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $4oTqF.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $42omo.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $42omo.useState)(false);
    const { messageSnoozed: messageSnoozed } = (0, $jVJ5P.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)($695eea2d8c17034b$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ariaLabelledby: ariaLabelledby,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #1868DB)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ef3ef5463323e3eb$export$ba7539b3ac68f9f1), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false,
                    customDropdownItems: customDropdownItems
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $l998X.jsx)((0, $f4e4a51aca50752c$export$b29014abf8076d54), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $jEPJt.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};
module.exports["AdControls"] = $695eea2d8c17034b$export$c25b8b7217045de9;

});

parcelRegister("jEPJt", function(module, exports) {
/* dismissalFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $3sFtD = parcelRequire("3sFtD");


var $gdv5Z = parcelRequire("gdv5Z");


var $aXWIB = parcelRequire("aXWIB");


var $4ORml = parcelRequire("4ORml");

const $f5d4e8188d1aa423$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper'; /**-Title--**/ 
const $f5d4e8188d1aa423$var$titleContainerStyles = {
    font: "_11c81qyo"
};
const $f5d4e8188d1aa423$var$Title = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $f5d4e8188d1aa423$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know"
        })
    }); /**--Description--**/ 
const $f5d4e8188d1aa423$var$Description = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often."
    }); /**--Confirm Icon--*/ 
const $f5d4e8188d1aa423$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #6A9A23)"
    }); /**-Confirm Dismiss Flag--*/ 
const $f5d4e8188d1aa423$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $4ORml.portalZIndexFix)($f5d4e8188d1aa423$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: $f5d4e8188d1aa423$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                icon: /*#__PURE__*/ (0, $l998X.jsx)($f5d4e8188d1aa423$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $l998X.jsx)($f5d4e8188d1aa423$var$Title, {}),
                description: /*#__PURE__*/ (0, $l998X.jsx)($f5d4e8188d1aa423$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};
module.exports["AdControlsFlag"] = $f5d4e8188d1aa423$export$6eb98925a948bca3;

});

parcelRegister("1RTRI", function(module, exports) {
$parcel$export(module.exports, "gql", () => $15c6136308fdd8ff$export$72e4926bf8358653);

var $hXuPC = parcelRequire("hXuPC");

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $3bfcd74b2d715b80$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $5c73d82885c0d95b$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $f355e6655efec7d9$var$LineRegExp = /\r\n|[\n\r]/g;
function $f355e6655efec7d9$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($f355e6655efec7d9$var$LineRegExp)){
        typeof match.index === 'number' || (0, $5c73d82885c0d95b$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $e60e50fe34eb4bba$export$96a9681e539deed(location) {
    return $e60e50fe34eb4bba$export$867940333fd9f869(location.source, (0, $f355e6655efec7d9$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $e60e50fe34eb4bba$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $e60e50fe34eb4bba$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $e60e50fe34eb4bba$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $e60e50fe34eb4bba$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $cb3705f2f9bcedf3$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $cb3705f2f9bcedf3$export$92d6ed0888e7cb7f extends Error {
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $e60e50fe34eb4bba$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $e60e50fe34eb4bba$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $cb3705f2f9bcedf3$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $cb3705f2f9bcedf3$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $cb3705f2f9bcedf3$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $f355e6655efec7d9$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $f355e6655efec7d9$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $3bfcd74b2d715b80$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $cb3705f2f9bcedf3$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
}
function $cb3705f2f9bcedf3$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $cb3705f2f9bcedf3$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $cb3705f2f9bcedf3$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $e5883ce23fa4e1d6$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $cb3705f2f9bcedf3$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $16302df1b8445427$export$18a2be9195644f38 {
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
}
class $16302df1b8445427$export$50792b0e93539fde {
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}
const $16302df1b8445427$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $16302df1b8445427$var$kindValues = new Set(Object.keys($16302df1b8445427$export$4fcd777a40ccf407));
function $16302df1b8445427$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $16302df1b8445427$var$kindValues.has(maybeKind);
}
/** Name */ var $16302df1b8445427$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($16302df1b8445427$export$f58c50edb4aef9d4 || ($16302df1b8445427$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $ad202f8515d7f662$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($ad202f8515d7f662$export$b45ffd2948484c41 || ($ad202f8515d7f662$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $f2121466e7e21b6e$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($f2121466e7e21b6e$export$a84bdc57c5122798 || ($f2121466e7e21b6e$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $3d32e10ec1c053ea$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $3d32e10ec1c053ea$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $3d32e10ec1c053ea$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $3d32e10ec1c053ea$export$45a677ea7cb6d5c8(code) {
    return $3d32e10ec1c053ea$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $3d32e10ec1c053ea$export$d3f406ff46035894(code) {
    return $3d32e10ec1c053ea$export$79c5d5217943d6a7(code) || $3d32e10ec1c053ea$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $69deba6634f6771d$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $69deba6634f6771d$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $69deba6634f6771d$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $3d32e10ec1c053ea$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $69deba6634f6771d$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $69deba6634f6771d$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $3d32e10ec1c053ea$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $3d32e10ec1c053ea$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $00e00807d92eb2af$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['DOT'] = '.';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($00e00807d92eb2af$export$8b9d26ab11394711 || ($00e00807d92eb2af$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $7fc6b9cbaa28b86a$export$6168dc8908a6c652 {
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $7fc6b9cbaa28b86a$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $16302df1b8445427$export$50792b0e93539fde)((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
}
function $7fc6b9cbaa28b86a$export$59ac0f4da287406a(kind) {
    return kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BANG || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).DOLLAR || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).AMP || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).DOT || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).SPREAD || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).EQUALS || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).AT || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_L || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_R || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).PIPE || kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $7fc6b9cbaa28b86a$var$isSupplementaryCodePoint(body, location) {
    return $7fc6b9cbaa28b86a$var$isLeadingSurrogate(body.charCodeAt(location)) && $7fc6b9cbaa28b86a$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $7fc6b9cbaa28b86a$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $7fc6b9cbaa28b86a$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
function $7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
function $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $16302df1b8445427$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $7fc6b9cbaa28b86a$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $7fc6b9cbaa28b86a$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $7fc6b9cbaa28b86a$var$readBlockString(lexer, position);
                return $7fc6b9cbaa28b86a$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $3d32e10ec1c053ea$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $7fc6b9cbaa28b86a$var$readNumber(lexer, position, code);
         // Name
        if ((0, $3d32e10ec1c053ea$export$45a677ea7cb6d5c8)(code)) return $7fc6b9cbaa28b86a$export$ccff49e992952c96(lexer, position);
        throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code) || $7fc6b9cbaa28b86a$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.` : `Invalid character: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.`);
    }
    return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $7fc6b9cbaa28b86a$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code)) ++position;
        else if ($7fc6b9cbaa28b86a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $7fc6b9cbaa28b86a$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $3d32e10ec1c053ea$export$727d9dbc4fbb948f)(code)) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.`);
    } else {
        position = $7fc6b9cbaa28b86a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $7fc6b9cbaa28b86a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $7fc6b9cbaa28b86a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $3d32e10ec1c053ea$export$45a677ea7cb6d5c8)(code)) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.`);
    return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, isFloat ? (0, $00e00807d92eb2af$export$8b9d26ab11394711).FLOAT : (0, $00e00807d92eb2af$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $7fc6b9cbaa28b86a$var$readDigits(lexer, start, firstCode) {
    if (!(0, $3d32e10ec1c053ea$export$727d9dbc4fbb948f)(firstCode)) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $3d32e10ec1c053ea$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $7fc6b9cbaa28b86a$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $7fc6b9cbaa28b86a$var$readEscapedUnicodeVariableWidth(lexer, position) : $7fc6b9cbaa28b86a$var$readEscapedUnicodeFixedWidth(lexer, position) : $7fc6b9cbaa28b86a$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code)) ++position;
        else if ($7fc6b9cbaa28b86a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $7fc6b9cbaa28b86a$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$7fc6b9cbaa28b86a$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $7fc6b9cbaa28b86a$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $7fc6b9cbaa28b86a$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $7fc6b9cbaa28b86a$var$read16BitHexCode(body, position + 2);
    if ($7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($7fc6b9cbaa28b86a$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $7fc6b9cbaa28b86a$var$read16BitHexCode(body, position + 8);
            if ($7fc6b9cbaa28b86a$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $7fc6b9cbaa28b86a$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $7fc6b9cbaa28b86a$var$readHexDigit(body.charCodeAt(position)) << 12 | $7fc6b9cbaa28b86a$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $7fc6b9cbaa28b86a$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $7fc6b9cbaa28b86a$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $7fc6b9cbaa28b86a$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $7fc6b9cbaa28b86a$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $7fc6b9cbaa28b86a$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $69deba6634f6771d$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($7fc6b9cbaa28b86a$var$isUnicodeScalarValue(code)) ++position;
        else if ($7fc6b9cbaa28b86a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7fc6b9cbaa28b86a$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
function $7fc6b9cbaa28b86a$export$ccff49e992952c96(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $3d32e10ec1c053ea$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $7fc6b9cbaa28b86a$export$c255480b061bd6aa(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}



var $6acb5 = parcelRequire("6acb5");






class $f2bc36c48068bdb8$export$1b46278b6a12726b {
    get [Symbol.toStringTag]() {
        return 'SchemaCoordinateLexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the current Lexer token.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF) {
            // Read the next token and form a link in the token linked-list.
            const nextToken = $f2bc36c48068bdb8$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
            token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
            nextToken.prev = token;
            token = nextToken;
        }
        return token;
    }
    constructor(source){
        /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   * Since a schema coordinate may not contain newline, this value is always 1.
   */ (0, $6acb5._)(this, "line", 1);
        /**
   * The character offset at which the current line begins.
   * Since a schema coordinate may not contain newline, this value is always 0.
   */ (0, $6acb5._)(this, "lineStart", 0);
        const startOfFileToken = new (0, $16302df1b8445427$export$50792b0e93539fde)((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
    }
}
/**
 * Gets the next token from the source starting at the given position.
 */ function $f2bc36c48068bdb8$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    const position = start;
    if (position < bodyLength) {
        const code = body.charCodeAt(position);
        switch(code){
            case 0x002e:
                // .
                return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).DOT, position, position + 1);
            case 0x0028:
                // (
                return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x003a:
                // :
                return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x0040:
                // @
                return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).AT, position, position + 1);
        } // Name
        if ((0, $3d32e10ec1c053ea$export$45a677ea7cb6d5c8)(code)) return (0, $7fc6b9cbaa28b86a$export$ccff49e992952c96)(lexer, position);
        throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character: ${(0, $7fc6b9cbaa28b86a$export$4b99857da92744e4)(lexer, position)}.`);
    }
    return (0, $7fc6b9cbaa28b86a$export$c255480b061bd6aa)(lexer, (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}


function $f56d30eda07d4474$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $f660af5baacd9411$var$MAX_ARRAY_LENGTH = 10;
const $f660af5baacd9411$var$MAX_RECURSIVE_DEPTH = 2;
function $f660af5baacd9411$export$9dec5d1b3b6a130d(value) {
    return $f660af5baacd9411$var$formatValue(value, []);
}
function $f660af5baacd9411$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $f660af5baacd9411$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $f660af5baacd9411$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($f660af5baacd9411$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $f660af5baacd9411$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $f660af5baacd9411$var$formatArray(value, seenValues);
    return $f660af5baacd9411$var$formatObject(value, seenValues);
}
function $f660af5baacd9411$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $f660af5baacd9411$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $f660af5baacd9411$var$MAX_RECURSIVE_DEPTH) return '[' + $f660af5baacd9411$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $f660af5baacd9411$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $f660af5baacd9411$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $f660af5baacd9411$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($f660af5baacd9411$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($f660af5baacd9411$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $f660af5baacd9411$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $b56abeba2aa4615e$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $b56abeba2aa4615e$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$b56abeba2aa4615e$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $f660af5baacd9411$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $b0573dd77850d896$export$1d2df86270c81ecb {
    get [Symbol.toStringTag]() {
        return 'Source';
    }
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $f56d30eda07d4474$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $f660af5baacd9411$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $f56d30eda07d4474$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $f56d30eda07d4474$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
}
function $b0573dd77850d896$export$75135ee9ed6e435b(source) {
    return (0, $b56abeba2aa4615e$export$ca03416d6c9e029e)(source, $b0573dd77850d896$export$1d2df86270c81ecb);
}



function $df149b351150f1ea$export$98e6a39c04603d36(source, options) {
    const parser = new $df149b351150f1ea$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $df149b351150f1ea$export$5303528d1070ff6f(source, options) {
    const parser = new $df149b351150f1ea$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF);
    return value;
}
function $df149b351150f1ea$export$e14c466bd0916f7a(source, options) {
    const parser = new $df149b351150f1ea$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF);
    return value;
}
function $df149b351150f1ea$export$28b8f402ccc88182(source, options) {
    const parser = new $df149b351150f1ea$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF);
    return type;
}
function $df149b351150f1ea$export$87ea0c241caf7f8f(source) {
    const sourceObj = (0, $b0573dd77850d896$export$75135ee9ed6e435b)(source) ? source : new (0, $b0573dd77850d896$export$1d2df86270c81ecb)(source);
    const lexer = new (0, $f2bc36c48068bdb8$export$1b46278b6a12726b)(sourceObj);
    const parser = new $df149b351150f1ea$export$7acfa6ed01010e37(source, {
        lexer: lexer
    });
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF);
    const coordinate = parser.parseSchemaCoordinate();
    parser.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF);
    return coordinate;
}
class $df149b351150f1ea$export$7acfa6ed01010e37 {
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $00e00807d92eb2af$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (hasDescription && keywordToken.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are not supported on shorthand queries.');
        if (keywordToken.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
            }
            if (hasDescription) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, only GraphQL definitions support descriptions.');
            switch(keywordToken.value){
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $16302df1b8445427$export$f58c50edb4aef9d4).QUERY,
            description: undefined,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const description = this.parseDescription();
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            description: description,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $16302df1b8445427$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $16302df1b8445427$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $16302df1b8445427$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            description: this.parseDescription(),
            variable: this.parseVariable(),
            type: (this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L, item, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).STRING:
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $00e00807d92eb2af$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).LIST,
            values: this.any((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_L, item, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, item, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).STRING) || this.peek((0, $00e00807d92eb2af$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$df149b351150f1ea$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $00e00807d92eb2af$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $00e00807d92eb2af$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $ad202f8515d7f662$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */ parseSchemaCoordinate() {
        const start = this._lexer.token;
        const ofDirective = this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        let memberName;
        if (!ofDirective && this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).DOT)) memberName = this.parseName();
        let argumentName;
        if ((ofDirective || memberName) && this.expectOptionalToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_L)) {
            argumentName = this.parseName();
            this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).COLON);
            this.expectToken((0, $00e00807d92eb2af$export$8b9d26ab11394711).PAREN_R);
        }
        if (ofDirective) {
            if (argumentName) return this.node(start, {
                kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE,
                name: name,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).DIRECTIVE_COORDINATE,
                name: name
            });
        } else if (memberName) {
            if (argumentName) return this.node(start, {
                kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).ARGUMENT_COORDINATE,
                name: name,
                fieldName: memberName,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).MEMBER_COORDINATE,
                name: name,
                memberName: memberName
            });
        }
        return this.node(start, {
            kind: (0, $f2121466e7e21b6e$export$a84bdc57c5122798).TYPE_COORDINATE,
            name: name
        });
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $16302df1b8445427$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$df149b351150f1ea$var$getTokenKindDesc(kind)}, found ${$df149b351150f1ea$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$df149b351150f1ea$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $00e00807d92eb2af$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$df149b351150f1ea$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $00e00807d92eb2af$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $e5883ce23fa4e1d6$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
    constructor(source, options = {}){
        const { lexer: lexer, ..._options } = options;
        if (lexer) this._lexer = lexer;
        else {
            const sourceObj = (0, $b0573dd77850d896$export$75135ee9ed6e435b)(source) ? source : new (0, $b0573dd77850d896$export$1d2df86270c81ecb)(source);
            this._lexer = new (0, $7fc6b9cbaa28b86a$export$6168dc8908a6c652)(sourceObj);
        }
        this._options = _options;
        this._tokenCounter = 0;
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $df149b351150f1ea$var$getTokenDesc(token) {
    const value = token.value;
    return $df149b351150f1ea$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $df149b351150f1ea$var$getTokenKindDesc(kind) {
    return (0, $7fc6b9cbaa28b86a$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $15c6136308fdd8ff$var$docCache = new Map();
var $15c6136308fdd8ff$var$fragmentSourceMap = new Map();
var $15c6136308fdd8ff$var$printFragmentWarnings = true;
var $15c6136308fdd8ff$var$experimentalFragmentVariables = false;
function $15c6136308fdd8ff$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $15c6136308fdd8ff$var$cacheKeyFromLoc(loc) {
    return $15c6136308fdd8ff$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $15c6136308fdd8ff$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $15c6136308fdd8ff$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $15c6136308fdd8ff$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($15c6136308fdd8ff$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $15c6136308fdd8ff$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, ast), {
        definitions: definitions
    });
}
function $15c6136308fdd8ff$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $15c6136308fdd8ff$var$parseDocument(source) {
    var cacheKey = $15c6136308fdd8ff$var$normalize(source);
    if (!$15c6136308fdd8ff$var$docCache.has(cacheKey)) {
        var parsed = (0, $df149b351150f1ea$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $15c6136308fdd8ff$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $15c6136308fdd8ff$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $15c6136308fdd8ff$var$docCache.set(cacheKey, $15c6136308fdd8ff$var$stripLoc($15c6136308fdd8ff$var$processFragments(parsed)));
    }
    return $15c6136308fdd8ff$var$docCache.get(cacheKey);
}
function $15c6136308fdd8ff$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $15c6136308fdd8ff$var$parseDocument(result);
}
function $15c6136308fdd8ff$export$657554ef4dc7ac2d() {
    $15c6136308fdd8ff$var$docCache.clear();
    $15c6136308fdd8ff$var$fragmentSourceMap.clear();
}
function $15c6136308fdd8ff$export$e4294e638636c6ab() {
    $15c6136308fdd8ff$var$printFragmentWarnings = false;
}
function $15c6136308fdd8ff$export$78cf889af350c840() {
    $15c6136308fdd8ff$var$experimentalFragmentVariables = true;
}
function $15c6136308fdd8ff$export$5290df9bbbd3cfa() {
    $15c6136308fdd8ff$var$experimentalFragmentVariables = false;
}
var $15c6136308fdd8ff$var$extras = {
    gql: $15c6136308fdd8ff$export$72e4926bf8358653,
    resetCaches: $15c6136308fdd8ff$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $15c6136308fdd8ff$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $15c6136308fdd8ff$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $15c6136308fdd8ff$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $15c6136308fdd8ff$var$extras.gql, gql_1.resetCaches = $15c6136308fdd8ff$var$extras.resetCaches, gql_1.disableFragmentWarnings = $15c6136308fdd8ff$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $15c6136308fdd8ff$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $15c6136308fdd8ff$var$extras.disableExperimentalFragmentVariables;
})($15c6136308fdd8ff$export$72e4926bf8358653 || ($15c6136308fdd8ff$export$72e4926bf8358653 = {}));
$15c6136308fdd8ff$export$72e4926bf8358653["default"] = $15c6136308fdd8ff$export$72e4926bf8358653;
var $15c6136308fdd8ff$export$2e2bcd8739ae039 = $15c6136308fdd8ff$export$72e4926bf8358653;

});

parcelRegister("2ViBN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable camelcase */ 
var $l998X = parcelRequire("l998X");


var $6767u = parcelRequire("6767u");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $42omo = parcelRequire("42omo");

const $7a9cbfd9ff88e4dc$var$styles = {
    root: "_2rko1rr0 _1reo15vq _18m915vq _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk7qp0",
    personIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1qvd1lya",
    boxAroundBadge: "_ca0qv77o _1qvdb3zs"
};
const $7a9cbfd9ff88e4dc$var$AvatarJoiningLine = ({ joiningLineHeight: joiningLineHeight = 0 })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            backgroundColor: "var(--ds-border, #0B120E24)",
            width: '3px',
            left: '25.75px',
            height: joiningLineHeight + 'px',
            position: 'absolute'
        }
    });
const $7a9cbfd9ff88e4dc$var$CustomAvatar = ({ src: src, size: size, alt: alt })=>{
    const [imageError, setImageError] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $7a9cbfd9ff88e4dc$var$styles.root,
        style: {
            width: `${size}px`,
            height: `${size}px`
        },
        children: src && !imageError ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: src,
            alt: alt || '',
            onError: ()=>setImageError(true),
            style: {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $7a9cbfd9ff88e4dc$var$styles.personIcon,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: alt || 'Default avatar'
            })
        })
    });
}; // CSS for the additional padding around the badge icon tile overlay since that component
// can't have a custom border radius
const $7a9cbfd9ff88e4dc$var$badgeIconStyles = {
    position: 'absolute',
    right: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-0, 0px)",
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    zIndex: 'flag',
    borderRadius: "var(--ds-radius-full, 9999px)",
    alignItems: 'center',
    justifyContent: 'center'
};
const $7a9cbfd9ff88e4dc$export$e2255cf6045e8d47 = ({ src: src, badgeIcon: badgeIcon, size: size = 54, avatarLineStartElementId: avatarLineStartElementId, avatarLineEndElementId: avatarLineEndElementId, joiningLineHeight: joiningLineHeight, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            position: 'relative',
            width: 'fit-content'
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($7a9cbfd9ff88e4dc$var$CustomAvatar, {
                src: src,
                ...props,
                size: size
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: (0, $ecnYn.xcss)({
                    ...$7a9cbfd9ff88e4dc$var$badgeIconStyles,
                    ...badgeIcon?.color && {
                        backgroundColor: badgeIcon.color
                    }
                }),
                children: badgeIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $7a9cbfd9ff88e4dc$var$styles.boxAroundBadge,
                    children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(badgeIcon.icon, {
                        label: badgeIcon.label || '',
                        color: "var(--ds-text-inverse, #FFFFFF)"
                    })
                })
            }),
            avatarLineStartElementId && avatarLineEndElementId && /*#__PURE__*/ (0, $l998X.jsx)($7a9cbfd9ff88e4dc$var$AvatarJoiningLine, {
                joiningLineHeight: joiningLineHeight
            })
        ]
    });
};
module.exports["Avatar"] = $7a9cbfd9ff88e4dc$export$e2255cf6045e8d47;

});

parcelRegister("7Rbnc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $g5lKx = parcelRequire("g5lKx");


var $j01vW = parcelRequire("j01vW");


var $2ViBN = parcelRequire("2ViBN");





var $6767u = parcelRequire("6767u");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $42omo = parcelRequire("42omo");

const $58c1466acc93c83f$var$badgeIconStyles = {
    position: 'absolute',
    right: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-0, 0px)",
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    zIndex: 'flag',
    borderRadius: "var(--ds-radius-full, 9999px)",
    alignItems: 'center',
    justifyContent: 'center'
};
const $58c1466acc93c83f$export$e2255cf6045e8d47 = ({ src: src, alt: alt, size: size = 54, badgeIcon: badgeIcon })=>{
    const [imageError, setImageError] = (0, $42omo.useState)(false);
    const { icon: BadgeIcon, label: label } = badgeIcon || {};
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            position: 'relative',
            width: 'fit-content'
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: (0, $ecnYn.xcss)({
                    width: `${size}px`,
                    height: `${size}px`,
                    borderRadius: 'radius.full',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'color.background.accent.gray.subtler'
                }),
                children: src && !imageError ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    src: src,
                    alt: alt || '',
                    onError: ()=>setImageError(true),
                    style: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: (0, $ecnYn.xcss)({
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        scale: 1.5
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                        label: alt || 'Default avatar'
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: (0, $ecnYn.xcss)({
                    ...$58c1466acc93c83f$var$badgeIconStyles,
                    ...badgeIcon?.color && {
                        backgroundColor: badgeIcon.color
                    }
                }),
                children: BadgeIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: (0, $ecnYn.xcss)({
                        paddingTop: 'space.025',
                        scale: 0.75
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)(BadgeIcon, {
                        label: label,
                        color: "var(--ds-text-inverse, #FFFFFF)"
                    })
                })
            })
        ]
    });
};






var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");

const $c8564e461e0bb63c$export$de65de8213222d10 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps
            }),
        label: "Close Flag",
        onClick: onClick,
        spacing: "compact"
    });
};


const $a2269b323e77b3e8$var$styles = {
    root: "_4t3i1osq _1e0c1txw _4cvresu3",
    flag: "_2rko12b0 _v564z97a _1yt4pxbi _16qs130s _1pbyni7l _bfhk1bhr _ca0qutpp _u5f3utpp",
    avatar: "_u5f3pxbi _ca0q1b66",
    headingSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _u5f31b66 _ca0q1b66",
    adControls: "_zulp1b66 _19bv12x7 _18u01wug",
    children: "_1bsb12aa"
};
const $a2269b323e77b3e8$var$Avatar = ({ avatarSrc: avatarSrc, avatarBadge: avatarBadge, avatarLineStartElementId: avatarLineStartElementId, avatarLineEndElementId: avatarLineEndElementId, joiningLineHeight: joiningLineHeight })=>{
    const isPlatformisedComponentEnabled = (0, $c6GJD.default).checkGate('post-office_enable_platformised-components-ccrn-ia');
    return isPlatformisedComponentEnabled && avatarBadge ? /*#__PURE__*/ (0, $l998X.jsx)((0, $58c1466acc93c83f$export$e2255cf6045e8d47), {
        src: avatarSrc,
        badgeIcon: {
            icon: avatarBadge.icon,
            color: avatarBadge.color,
            label: avatarBadge.label
        }
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2ViBN.Avatar), {
        src: avatarSrc,
        badgeIcon: avatarBadge,
        avatarLineStartElementId: avatarLineStartElementId,
        avatarLineEndElementId: avatarLineEndElementId,
        joiningLineHeight: joiningLineHeight
    });
};
const $a2269b323e77b3e8$export$48ea269755562084 = ({ width: width, onClose: onClose, onNotInterested: onNotInterested, whyAmISeeingThisContent: whyAmISeeingThisContent, avatarSrc: avatarSrc, avatarBadge: avatarBadge, avatarLineStartElementId: avatarLineStartElementId, avatarLineEndElementId: avatarLineEndElementId, headingSection: headingSection, bottomLayer: bottomLayer, children: children, joiningLineHeight: joiningLineHeight })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a2269b323e77b3e8$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $a2269b323e77b3e8$var$styles.flag,
            style: {
                width: `${width}px`,
                minWidth: `${width}px`,
                maxWidth: `${width}px`
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $a2269b323e77b3e8$var$styles.avatar,
                            children: avatarSrc && /*#__PURE__*/ (0, $l998X.jsx)($a2269b323e77b3e8$var$Avatar, {
                                avatarSrc: avatarSrc,
                                avatarBadge: avatarBadge,
                                avatarLineStartElementId: avatarLineStartElementId,
                                avatarLineEndElementId: avatarLineEndElementId,
                                joiningLineHeight: joiningLineHeight
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.100",
                            xcss: $a2269b323e77b3e8$var$styles.headingSection,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    children: [
                                        headingSection,
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            xcss: $a2269b323e77b3e8$var$styles.adControls,
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $j01vW.AdControls), {
                                                    zIndex: (0, $g5lKx.layers).flag(),
                                                    onDismissed: onNotInterested,
                                                    showWhyAmISeeingThis: true,
                                                    whyAmISeeingThisModalContent: whyAmISeeingThisContent,
                                                    spacing: "compact"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c8564e461e0bb63c$export$de65de8213222d10), {
                                                    onClick: onClose
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $a2269b323e77b3e8$var$styles.children,
                                    children: children
                                })
                            ]
                        })
                    ]
                }),
                bottomLayer
            ]
        })
    });
};
module.exports["Flag"] = $a2269b323e77b3e8$export$48ea269755562084;

});

parcelRegister("bEbfS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $a3fRD = parcelRequire("a3fRD");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $7G5ZJ = parcelRequire("7G5ZJ");


var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9GPee = parcelRequire("9GPee");

var $d7efba379f02561c$export$ae1bec9d610f93d3 = /*#__PURE__*/ function(ReactionStatus) {
    ReactionStatus["ready"] = "READY";
    ReactionStatus["loading"] = "LOADING";
    ReactionStatus["error"] = "ERROR";
    ReactionStatus["notLoaded"] = "NOT_LOADED";
    ReactionStatus["disabled"] = "DISABLED";
    return ReactionStatus;
}({});


const $9d582c25b13525f6$export$9ea5bee638a1f6a = (reactionsList)=>{
    return reactionsList?.reactionsSummary?.reactionsSummaryForEmoji.map((emojiSummary)=>{
        if (!emojiSummary) return null;
        return {
            ari: reactionsList.reactionsSummary?.ari ?? '',
            containerAri: reactionsList.reactionsSummary?.containerAri ?? '',
            emojiId: emojiSummary.emojiId,
            count: emojiSummary.count,
            reacted: emojiSummary.reacted
        };
    }).filter(Boolean);
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a3c366fe08743442$var$placeholderContainerStyles = null;
const $a3c366fe08743442$var$reactionPillStyles = null;
const $a3c366fe08743442$var$reactionIconStyles = null;
const $a3c366fe08743442$var$DEFAULT_NUM_PILLS = 2;
const $a3c366fe08743442$export$47a91e92112986d6 = ()=>{
    const renderPlaceholder = (numPills)=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
            "data-testid": "reactions-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
            ]),
            children: [
                Array(numPills).fill('').map((_, i)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                        "data-testid": "reactions-pill",
                        className: (0, $gMc0m.default)([
                            "_2rkogktf _1bsbor1b _4t3i1tcg _bfhkvkf5 _2hwx1b66"
                        ])
                    }, i)),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "data-testid": "reaction-icon",
                    className: (0, $gMc0m.default)([
                        "_2rkogktf _1bsb1crf _4t3i1crf _bfhkvkf5 _18u012x7"
                    ])
                })
            ]
        });
    return renderPlaceholder($a3c366fe08743442$var$DEFAULT_NUM_PILLS);
};


const $fbfafaa5725e4a86$var$noop = ()=>{};
const $fbfafaa5725e4a86$export$dc29e9fd3c81507a = ({ cloudId: cloudId, containerId: containerId, containerType: containerType = 'page', contentId: contentId, reactionsList: reactionsList, emojiProvider: emojiProvider, addReaction: addReaction, deleteReaction: deleteReaction, onMutationCompleted: onMutationCompleted, onMutationError: onMutationError, experienceTrackingAttributes: experienceTrackingAttributes, summaryViewEnabled: summaryViewEnabled = false, contentType: contentType, quickReactionEmojis: quickReactionEmojis, showAddReactionText: showAddReactionText, particleEffectByEmoji: particleEffectByEmoji, fireAnalyticsEvents: fireAnalyticsEvents = true })=>{
    const reactionsSummary = (0, $9d582c25b13525f6$export$9ea5bee638a1f6a)(reactionsList);
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const { messageClicked: messageClicked } = (0, $jVJ5P.useMessageEvent)();
    const reactionsSummaryError = false; // track api failure for fetching reactions summary
    const handleReaction = (0, $42omo.useCallback)((emojiId, isAdd)=>{
        if (addReaction && deleteReaction) {
            // do mutation to add or delete reaction
            const commitMutation = isAdd ? addReaction : deleteReaction;
            // call the callback from coming from message creator
            commitMutation({
                variables: {
                    cloudId: cloudId,
                    containerId: containerId,
                    containerType: containerType.toUpperCase(),
                    contentId: contentId,
                    contentType: contentType,
                    emojiId: emojiId
                },
                onCompleted: onMutationCompleted,
                onError: onMutationError
            });
            // Adding an override for this call because some templates might not want these events
            if (fireAnalyticsEvents) {
                messageClicked().catch(()=>{});
                // Send Experience tracking event
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'reactionEmoji',
                        clickedElement: 'button',
                        buttonType: 'primary'
                    },
                    action: {
                        actionType: 'acknowledge'
                    },
                    additionalMetadataFromFrontend: {
                        ...experienceTrackingAttributes,
                        isReactionAdded: isAdd.toString(),
                        isReactionRemoved: (!isAdd).toString()
                    }
                }).catch(()=>{});
            }
        }
    }, [
        addReaction,
        deleteReaction,
        contentId,
        contentType,
        containerId,
        containerType,
        cloudId,
        onMutationCompleted,
        onMutationError
    ]);
    const onReactionClick = (0, $42omo.useCallback)((emojiId)=>{
        const existingReaction = reactionsSummary.find((reaction)=>reaction.emojiId === emojiId);
        handleReaction(emojiId, !existingReaction?.reacted);
    }, [
        reactionsSummary,
        handleReaction
    ]);
    const onSelection = (0, $42omo.useCallback)((emojiId)=>{
        const existingReaction = reactionsSummary.find((reaction)=>reaction.emojiId === emojiId);
        if (!existingReaction?.reacted) handleReaction(emojiId, true);
    }, [
        reactionsSummary,
        handleReaction
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $a3c366fe08743442$export$47a91e92112986d6), {}),
        children: reactionsSummaryError ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-accent-gray, #8993A4)",
                    label: "Icon showing an error with rendering reactions",
                    size: "small"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: 'color.text.subtlest',
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $9GPee.default).viewReactionsError
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7G5ZJ.Reactions), {
            reactions: reactionsSummary,
            loadReaction: $fbfafaa5725e4a86$var$noop,
            onSelection: onSelection,
            onReactionClick: onReactionClick,
            status: (0, $d7efba379f02561c$export$ae1bec9d610f93d3).ready,
            emojiProvider: emojiProvider,
            summaryViewEnabled: summaryViewEnabled,
            allowAllEmojis: true,
            emojiPickerSize: "medium",
            miniMode: true,
            noRelativeContainer: true,
            showAddReactionText: showAddReactionText,
            quickReactionEmojis: quickReactionEmojis,
            particleEffectByEmoji: particleEffectByEmoji
        })
    });
};
module.exports["ReactionWrapper"] = $fbfafaa5725e4a86$export$dc29e9fd3c81507a;

});

parcelRegister("9GPee", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $25290f7ba264bb8b$var$messages = (0, $aXWIB.defineMessages)({
    viewReactionsError: {
        defaultMessage: "Reactions failed to load",
        id: "growth.confluenceNudgeFlag.viewReactionsError"
    },
    replyFieldGenericError: {
        defaultMessage: "Failed to send comment. Please try again later.",
        id: "growth.confluenceNudgeFlag.replyFieldGenericError"
    }
});
var $25290f7ba264bb8b$export$2e2bcd8739ae039 = $25290f7ba264bb8b$var$messages;
module.exports["default"] = $25290f7ba264bb8b$export$2e2bcd8739ae039;

});

parcelRegister("1PqTV", function(module, exports) {

var $1RTRI = parcelRequire("1RTRI");

const $f9b69088636d0970$export$e7206206aefe06e = (0, $1RTRI.gql)`
	mutation mainAddReactionMutation(
		$cloudId: ID!
		$containerId: String!
		$containerType: ContainerType!
		$contentId: String!
		$contentType: GraphQLReactionContentType!
		$emojiId: String!
	) {
		addReaction(
			cloudId: $cloudId
			containerId: $containerId
			containerType: $containerType
			contentId: $contentId
			contentType: $contentType
			emojiId: $emojiId
		) {
			ari
			containerAri
			emojiId
		}
	}
`;
const $f9b69088636d0970$export$2c64d45e8e2a4223 = (0, $1RTRI.gql)`
	mutation mainDeleteReactionMutation(
		$cloudId: ID!
		$containerId: String!
		$containerType: ContainerType!
		$contentId: String!
		$contentType: GraphQLReactionContentType!
		$emojiId: String!
	) {
		deleteReaction(
			cloudId: $cloudId
			containerId: $containerId
			containerType: $containerType
			contentId: $contentId
			contentType: $contentType
			emojiId: $emojiId
		) {
			ari
			containerAri
			emojiId
		}
	}
`;
module.exports["addReactionQuery"] = $f9b69088636d0970$export$e7206206aefe06e;
module.exports["deleteReactionQuery"] = $f9b69088636d0970$export$2c64d45e8e2a4223;

});

parcelRegister("hFqI4", function(module, exports) {

var $1RTRI = parcelRequire("1RTRI");

const $d2b9194847384925$export$304b40a6d5105ff7 = (0, $1RTRI.gql)`
	query mainReactionsSummaryQuery(
		$cloudId: ID!
		$contentId: ID!
		$contentType: String!
		$containerId: ID!
		$containerType: String
	) {
		reactionsSummary(
			cloudId: $cloudId
			contentId: $contentId
			contentType: $contentType
			containerId: $containerId
			containerType: $containerType
		) {
			ari
			containerAri
			reactionsSummaryForEmoji {
				emojiId
				count
				reacted
			}
		}
	}
`;
module.exports["getReactionsQuery"] = $d2b9194847384925$export$304b40a6d5105ff7;

});

parcelRegister("4ORml", function(module, exports) {
const $c6c29df3bce28b1a$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $c6c29df3bce28b1a$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$c6c29df3bce28b1a$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $c6c29df3bce28b1a$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $c6c29df3bce28b1a$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};
module.exports["portalZIndexFix"] = $c6c29df3bce28b1a$export$cef2f5415067aeab;

});


//# sourceMappingURL=PageLayout.8d9bf7b8.js.map
